.Menu {
  display: flex;
  align-items: center;
}

.MenuItem {
  padding: var(--space-xs) var(--space-m);
  color: var(--color-black);
  font-weight: var(--font-weight-bold);
  text-decoration: none;
  text-transform: uppercase;
}

.MenuItemActive {
  background-color: var(--color-accent-1);
  color: var(--color-white);
}
